/**
 * Generated from ch6_p14.fla
 */
export function ch6_p14(this: Ich6_p14) {
	const ringLetters = this.ringLetters;
	if (!ringLetters[0] && ringLetters.elementFactory) {
		ringLetters[0] = ringLetters.elementFactory(0,undefined);
	}
	if (ringLetters[0]) {
		ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersr_1.call(ringLetters[0] as Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersr_1);
		ringLetters[0].x = 182.75;
		ringLetters[0].y = 638;
		ringLetters[0].width = 155.50;
		ringLetters[0].height = 151.00;
		ringLetters[0].alpha = 1;
		if (ringLetters[0].onLayout) ringLetters[0].onLayout();
	}
	if (!ringLetters[1] && ringLetters.elementFactory) {
		ringLetters[1] = ringLetters.elementFactory(1,undefined);
	}
	if (ringLetters[1]) {
		ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersr_2.call(ringLetters[1] as Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersr_2);
		ringLetters[1].x = 275;
		ringLetters[1].y = 567;
		ringLetters[1].width = 181.00;
		ringLetters[1].height = 202.00;
		ringLetters[1].alpha = 1;
		if (ringLetters[1].onLayout) ringLetters[1].onLayout();
	}
	if (!ringLetters[2] && ringLetters.elementFactory) {
		ringLetters[2] = ringLetters.elementFactory(2,undefined);
	}
	if (ringLetters[2]) {
		ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersr_3.call(ringLetters[2] as Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersr_3);
		ringLetters[2].x = 389.75;
		ringLetters[2].y = 466.25;
		ringLetters[2].width = 321.50;
		ringLetters[2].height = 301.50;
		ringLetters[2].alpha = 1;
		if (ringLetters[2].onLayout) ringLetters[2].onLayout();
	}
	if (!ringLetters[3] && ringLetters.elementFactory) {
		ringLetters[3] = ringLetters.elementFactory(3,undefined);
	}
	if (ringLetters[3]) {
		ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersr.call(ringLetters[3] as Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersr);
		ringLetters[3].x = 588.25;
		ringLetters[3].y = 324.75;
		ringLetters[3].width = 369.50;
		ringLetters[3].height = 423.50;
		ringLetters[3].alpha = 1;
		if (ringLetters[3].onLayout) ringLetters[3].onLayout();
	}
	if (!ringLetters[4] && ringLetters.elementFactory) {
		ringLetters[4] = ringLetters.elementFactory(4,undefined);
	}
	if (ringLetters[4]) {
		ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersi_1.call(ringLetters[4] as Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersi_1);
		ringLetters[4].x = 686.5;
		ringLetters[4].y = 303.5;
		ringLetters[4].width = 114.00;
		ringLetters[4].height = 440.00;
		ringLetters[4].alpha = 1;
		if (ringLetters[4].onLayout) ringLetters[4].onLayout();
	}
	if (!ringLetters[5] && ringLetters.elementFactory) {
		ringLetters[5] = ringLetters.elementFactory(5,undefined);
	}
	if (ringLetters[5]) {
		ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersi_2.call(ringLetters[5] as Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersi_2);
		ringLetters[5].x = 804.5;
		ringLetters[5].y = 295;
		ringLetters[5].width = 49.00;
		ringLetters[5].height = 369.00;
		ringLetters[5].alpha = 1;
		if (ringLetters[5].onLayout) ringLetters[5].onLayout();
	}
	if (!ringLetters[6] && ringLetters.elementFactory) {
		ringLetters[6] = ringLetters.elementFactory(6,undefined);
	}
	if (ringLetters[6]) {
		ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersi.call(ringLetters[6] as Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersi);
		ringLetters[6].x = 952;
		ringLetters[6].y = 312.5;
		ringLetters[6].width = 95.00;
		ringLetters[6].height = 375.00;
		ringLetters[6].alpha = 1;
		if (ringLetters[6].onLayout) ringLetters[6].onLayout();
	}
	if (!ringLetters[7] && ringLetters.elementFactory) {
		ringLetters[7] = ringLetters.elementFactory(7,undefined);
	}
	if (ringLetters[7]) {
		ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersn_1.call(ringLetters[7] as Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersn_1);
		ringLetters[7].x = 1110.75;
		ringLetters[7].y = 358;
		ringLetters[7].width = 226.50;
		ringLetters[7].height = 343.00;
		ringLetters[7].alpha = 1;
		if (ringLetters[7].onLayout) ringLetters[7].onLayout();
	}
	if (!ringLetters[8] && ringLetters.elementFactory) {
		ringLetters[8] = ringLetters.elementFactory(8,undefined);
	}
	if (ringLetters[8]) {
		ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersn.call(ringLetters[8] as Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersn);
		ringLetters[8].x = 1305.75;
		ringLetters[8].y = 425;
		ringLetters[8].width = 183.50;
		ringLetters[8].height = 307.00;
		ringLetters[8].alpha = 1;
		if (ringLetters[8].onLayout) ringLetters[8].onLayout();
	}
	if (!ringLetters[9] && ringLetters.elementFactory) {
		ringLetters[9] = ringLetters.elementFactory(9,undefined);
	}
	if (ringLetters[9]) {
		ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersg_1.call(ringLetters[9] as Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersg_1);
		ringLetters[9].x = 1458.75;
		ringLetters[9].y = 463.5;
		ringLetters[9].width = 140.50;
		ringLetters[9].height = 233.00;
		ringLetters[9].alpha = 1;
		if (ringLetters[9].onLayout) ringLetters[9].onLayout();
	}
	if (!ringLetters[10] && ringLetters.elementFactory) {
		ringLetters[10] = ringLetters.elementFactory(10,undefined);
	}
	if (ringLetters[10]) {
		ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersg.call(ringLetters[10] as Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersg);
		ringLetters[10].x = 1556;
		ringLetters[10].y = 485.5;
		ringLetters[10].width = 92.00;
		ringLetters[10].height = 176.00;
		ringLetters[10].alpha = 1;
		if (ringLetters[10].onLayout) ringLetters[10].onLayout();
	}
	const horse = this.horse;
	if (!horse[0] && horse.elementFactory) {
		horse[0] = horse.elementFactory(0,undefined);
	}
	if (horse[0]) {
		ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_horse.call(horse[0] as Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_horse);
		horse[0].x = 613.25;
		horse[0].y = 768;
		horse[0].width = 648.50;
		horse[0].height = 683.50;
		horse[0].alpha = 1;
		if (horse[0].onLayout) horse[0].onLayout();
	}
	if (!horse[1] && horse.elementFactory) {
		horse[1] = horse.elementFactory(1,undefined);
	}
	if (horse[1]) {
		ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p15_horse.call(horse[1] as Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p15_horse);
		horse[1].x = 643.25;
		horse[1].y = 768;
		horse[1].width = 588.50;
		horse[1].height = 667.00;
		horse[1].alpha = 1;
		if (horse[1].onLayout) horse[1].onLayout();
	}
	const holly = this.holly;
	if (!holly[0] && holly.elementFactory) {
		holly[0] = holly.elementFactory(0,undefined);
	}
	if (holly[0]) {
		ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_holly.call(holly[0] as Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_holly);
		holly[0].x = 878.25;
		holly[0].y = 768;
		holly[0].width = 366.50;
		holly[0].height = 569.00;
		holly[0].alpha = 1;
		if (holly[0].onLayout) holly[0].onLayout();
	}
	if (!holly[1] && holly.elementFactory) {
		holly[1] = holly.elementFactory(1,undefined);
	}
	if (holly[1]) {
		ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p15_holly.call(holly[1] as Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p15_holly);
		holly[1].x = 871.75;
		holly[1].y = 768;
		holly[1].width = 236.50;
		holly[1].height = 568.00;
		holly[1].alpha = 1;
		if (holly[1].onLayout) holly[1].onLayout();
	}
	const tyler = this.tyler;
	if (!tyler[0] && tyler.elementFactory) {
		tyler[0] = tyler.elementFactory(0,undefined);
	}
	if (tyler[0]) {
		ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_tyler.call(tyler[0] as Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_tyler);
		tyler[0].x = 1120;
		tyler[0].y = 768;
		tyler[0].width = 308.00;
		tyler[0].height = 649.50;
		tyler[0].alpha = 1;
		if (tyler[0].onLayout) tyler[0].onLayout();
	}
	if (!tyler[1] && tyler.elementFactory) {
		tyler[1] = tyler.elementFactory(1,undefined);
	}
	if (tyler[1]) {
		ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p15_tyler.call(tyler[1] as Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p15_tyler);
		tyler[1].x = 1199.75;
		tyler[1].y = 768;
		tyler[1].width = 285.50;
		tyler[1].height = 649.50;
		tyler[1].alpha = 1;
		if (tyler[1].onLayout) tyler[1].onLayout();
	}
	const rain = this.rain;
	if (!rain[0] && rain.elementFactory) {
		rain[0] = rain.elementFactory(0,undefined);
	}
	if (rain[0]) {
		ch6_p14_hh_ch6_72dpi_p014015psdAssetrainoverlayrain2.call(rain[0] as Ich6_p14_hh_ch6_72dpi_p014015psdAssetrainoverlayrain2);
		rain[0].x = 820.5;
		rain[0].y = 384;
		rain[0].width = 1641.00;
		rain[0].height = 768.00;
		rain[0].alpha = 1;
		if (rain[0].onLayout) rain[0].onLayout();
	}
	if (!rain[1] && rain.elementFactory) {
		rain[1] = rain.elementFactory(1,undefined);
	}
	if (rain[1]) {
		ch6_p14_hh_ch6_72dpi_p014015psdAssetrainoverlayrain1.call(rain[1] as Ich6_p14_hh_ch6_72dpi_p014015psdAssetrainoverlayrain1);
		rain[1].x = 813.75;
		rain[1].y = 388.5;
		rain[1].width = 1600.50;
		rain[1].height = 759.00;
		rain[1].alpha = 1;
		if (rain[1].onLayout) rain[1].onLayout();
	}
	const bg = this.bg;
	ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const ringbg = this.ringbg;
	ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringbg.call(this.ringbg);
	ringbg.x = 845.5;
	ringbg.y = 384;
	ringbg.width = 1637.00;
	ringbg.height = 768.00;
	ringbg.alpha = 1.00;
	if (ringbg.onLayout) ringbg.onLayout();
	const frameRight = this.frameRight;
	ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_wcframeRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 354.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const frameLeft = this.frameLeft;
	ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_wcframeLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 342.50;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	return this;
}
function ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_bg(this: Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p14_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringbg(this: Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringbg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p14_ringbg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersr_1(this: Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersr_1) {
	if (this.setLayoutTexture) this.setLayoutTexture("r_1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersr_2(this: Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersr_2) {
	if (this.setLayoutTexture) this.setLayoutTexture("r_2", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersr_3(this: Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersr_3) {
	if (this.setLayoutTexture) this.setLayoutTexture("r_3", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersr(this: Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersr) {
	if (this.setLayoutTexture) this.setLayoutTexture("r", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersi_1(this: Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersi_1) {
	if (this.setLayoutTexture) this.setLayoutTexture("i_1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersi_2(this: Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersi_2) {
	if (this.setLayoutTexture) this.setLayoutTexture("i_2", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersi(this: Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersi) {
	if (this.setLayoutTexture) this.setLayoutTexture("i", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersn_1(this: Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersn_1) {
	if (this.setLayoutTexture) this.setLayoutTexture("n_1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersn(this: Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersn) {
	if (this.setLayoutTexture) this.setLayoutTexture("n", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersg_1(this: Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersg_1) {
	if (this.setLayoutTexture) this.setLayoutTexture("g_1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersg(this: Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersg) {
	if (this.setLayoutTexture) this.setLayoutTexture("g", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_horse(this: Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_horse) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p14_horse", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_holly(this: Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p14_holly", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_tyler(this: Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_tyler) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p14_tyler", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p15_horse(this: Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p15_horse) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p15_horse", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p15_holly(this: Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p15_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p15_holly", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p15_tyler(this: Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p15_tyler) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p15_tyler", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p14_hh_ch6_72dpi_p014015psdAssetrainoverlayrain2(this: Ich6_p14_hh_ch6_72dpi_p014015psdAssetrainoverlayrain2) {
	if (this.setLayoutTexture) this.setLayoutTexture("rain2", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("overlay");
	return this;
}
function ch6_p14_hh_ch6_72dpi_p014015psdAssetrainoverlayrain1(this: Ich6_p14_hh_ch6_72dpi_p014015psdAssetrainoverlayrain1) {
	if (this.setLayoutTexture) this.setLayoutTexture("rain1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_wcframeRframe(this: Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_wcframeRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_wcframeLframe(this: Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_wcframeLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
interface Ich6_p14Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich6_p14Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich6_p14Sprite extends Ich6_p14Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich6_p14Text extends Ich6_p14Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich6_p14Polygon extends Array<number> {
}
interface Ich6_p14 {
	readonly ringLetters: Ich6_p14Array<Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersr_1|Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersr_2|Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersr_3|Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersr|Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersi_1|Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersi_2|Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersi|Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersn_1|Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersn|Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersg_1|Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersg>;
	readonly horse: Ich6_p14Array<Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_horse|Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p15_horse>;
	readonly holly: Ich6_p14Array<Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_holly|Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p15_holly>;
	readonly tyler: Ich6_p14Array<Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_tyler|Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p15_tyler>;
	readonly rain: Ich6_p14Array<Ich6_p14_hh_ch6_72dpi_p014015psdAssetrainoverlayrain2|Ich6_p14_hh_ch6_72dpi_p014015psdAssetrainoverlayrain1>;
	readonly bg: Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_bg;
	readonly ringbg: Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringbg;
	readonly frameRight: Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_wcframeRframe;
	readonly frameLeft: Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_wcframeLframe;
}
interface Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_bg extends Ich6_p14Sprite {
}
interface Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringbg extends Ich6_p14Sprite {
}
interface Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersr_1 extends Ich6_p14Sprite {
}
interface Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersr_2 extends Ich6_p14Sprite {
}
interface Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersr_3 extends Ich6_p14Sprite {
}
interface Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersr extends Ich6_p14Sprite {
}
interface Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersi_1 extends Ich6_p14Sprite {
}
interface Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersi_2 extends Ich6_p14Sprite {
}
interface Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersi extends Ich6_p14Sprite {
}
interface Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersn_1 extends Ich6_p14Sprite {
}
interface Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersn extends Ich6_p14Sprite {
}
interface Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersg_1 extends Ich6_p14Sprite {
}
interface Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_ringlettersg extends Ich6_p14Sprite {
}
interface Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_horse extends Ich6_p14Sprite {
}
interface Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_holly extends Ich6_p14Sprite {
}
interface Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_tyler extends Ich6_p14Sprite {
}
interface Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p15_horse extends Ich6_p14Sprite {
}
interface Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p15_holly extends Ich6_p14Sprite {
}
interface Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p15_tyler extends Ich6_p14Sprite {
}
interface Ich6_p14_hh_ch6_72dpi_p014015psdAssetrainoverlayrain2 extends Ich6_p14Sprite {
}
interface Ich6_p14_hh_ch6_72dpi_p014015psdAssetrainoverlayrain1 extends Ich6_p14Sprite {
}
interface Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_wcframeRframe extends Ich6_p14Sprite {
}
interface Ich6_p14_hh_ch6_72dpi_p014015psdAssetchp6_p14_wcframeLframe extends Ich6_p14Sprite {
}
